module.exports = __webpack_public_path__ + "img/ICONSPEEDY.63d26ceb.webp";